"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagCF = function FlagCF(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3v-60H216.6v60a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 124)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "136.18",
    width: "409.6",
    height: "67.09",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "69.09",
    width: "409.6",
    height: "67.09",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-54.91H-193v-60a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 124)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "172.26",
    y: "2",
    width: "67.09",
    height: "268.36",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-131.8-113l5.89,17.67,18.63.14a1.5,1.5,0,0,1,.88,2.71l-15,11.07,5.62,17.76a1.5,1.5,0,0,1-2.3,1.67l-15.16-10.83-15.15,10.83a1.5,1.5,0,0,1-2.3-1.67l5.61-17.76-15-11.07a1.5,1.5,0,0,1,.88-2.71l18.63-.14,5.89-17.67a1.5,1.5,0,0,1,2.85,0Zm0,0",
    transform: "translate(194 124)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagCF;
exports["default"] = _default;